import { UPDATE_TRACKING_SESSION_ID } from "./trackingSessionIdReducer"

export const updateTrackingSessionId = (id) => ({
    type: UPDATE_TRACKING_SESSION_ID,
    payload: id
})